<template>
  <div class="card product-summary-card">
    <div class="card-column" :style="{ width: leftColumnWidth }">
      <slot name="left"></slot>
    </div>
    <div v-if="rightColumnWidth !== '0%'" class="card-column" :style="{ width: rightColumnWidth }">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductSummaryCard',
  props: {
    leftColumnWidth: {
      type: String,
      default: 'auto',
    },
    rightColumnWidth: {
      type: String,
      default: 'auto',
    },
  },
};
</script>

<style lang="scss" scoped>
.product-summary-card {
  @include flex-row;
  padding: 2rem 1rem;
  justify-content: space-between;
  margin: 1rem 0;
  column-gap: 1.5rem;
  background-color: $WHITE;
  border-radius: 16px;
  box-shadow: 0 2px 6px 0 rgba(22,22,29,.06),0 2px 4px 0 rgba(22,22,29,.02);
  @include mobile {
    @include flex-col;
    row-gap: 1.5rem;
  }
}

.card-column {
  padding: 0 1.5rem;

  &:nth-child(2) {
    border-left: 1px solid $GREY_300;
  }

  @include mobile {
    padding: 1.5rem 0;

    &:nth-child(2) {
      border-top: 1px solid $GREY_300;
      border-left: unset;
    }
  }

  *:not(svg) {
    min-width: rem(280);
  }

  p.no-margin {
    margin: 0;
  }
}

.header {
  font-size: $DESKTOP_H4_SIZE;
  margin-bottom: 1.5rem;

  @include mobile {
    font-size: $MOBILE_H4_SIZE;
  }
}
</style>
